import { useQuery } from '@apollo/client/react';
import { DatePicker } from '@optools/components/datetime/date-picker';
import { dateSchema } from '@optools/schemas/date';
import { GET_LITMUS_SCHEDULE } from '@optools/services/operator-gateway/media-validation/queries';
import { LitmusSchedule } from '@optools/tools/media-validation/components/litmus-schedule';
import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

export const Route = createFileRoute('/_auth/media-validation/litmus')({
  component: RouteComponent,
  validateSearch: zodValidator(dateSchema),
});

export function RouteComponent() {
  const { date } = useSearch({ from: '/_auth/media-validation/litmus' });
  const navigate = useNavigate({ from: Route.fullPath });
  const handleDateChange = (newDate: string) => {
    return navigate({ search: (search) => ({ ...search, date: newDate }) });
  };
  const { data, loading } = useQuery(GET_LITMUS_SCHEDULE, { variables: { date } });

  return (
    <LitmusSchedule loading={loading} schedule={data?.schedule}>
      <DatePicker date={date} setDate={handleDateChange} />
    </LitmusSchedule>
  );
}
